import { render, staticRenderFns } from "./customerVisits.vue?vue&type=template&id=1c517dc0&scoped=true&"
import script from "./customerVisits.vue?vue&type=script&lang=js&"
export * from "./customerVisits.vue?vue&type=script&lang=js&"
import style0 from "./customerVisits.vue?vue&type=style&index=0&id=1c517dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c517dc0",
  null
  
)

export default component.exports